<template>
  <v-app>
    <v-card>
      <v-card-title>
        <h3>Total Payable</h3>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-center">
            <h1 class="text-success">Rs.{{ library_fine }}/-</h1>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn class="btn btn-primary text-white mr-2" outlined
                   @click="settle_dialog =  true; payable= 0">Settle Fine
            </v-btn>
            <v-btn class="btn btn-primary text-white mr-2" outlined @click="edit_fine_dialog =  true; payable= library_fine">Edit Fine</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <v-dialog persistent v-model="settle_dialog" width="300px">
      <v-card>
        <v-card-title>Settle Fine</v-card-title>
        <v-card-text>
<!--          <v-row>-->
<!--            <v-col cols="12">-->
<!--              <v-text-field outlined dense v-model="payable" label="Total Fine to be paid">-->
<!--              </v-text-field>-->
<!--            </v-col>-->
<!--          </v-row>-->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn btn-primary text-white mr-2" outlined @click="settleFine">Settle Fine</v-btn>
          <v-btn class="btn btn-danger text-white mr-2" outlined @click="settle_dialog= false; payable= 0"> Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="edit_fine_dialog" width="300px">
      <v-card>
        <v-card-title>Settle Fine</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field outlined dense v-model="payable" label="Total Fine to be paid">
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn btn-primary text-white mr-2" outlined @click="editFine">Edit Fine</v-btn>
          <v-btn class="btn btn-danger text-white mr-2" outlined @click="edit_fine_dialog= false; payable= 0"> Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  name: "Fine",
  props: ['user', 'library_fine'],
  data() {
    return {
      settle_dialog: false,
      edit_fine_dialog: false,
      payable: 0
    }
  }, mounted() {
    this.payable = this.library_fine
  }, methods: {
    settleFine() {
      this.$confirm({
        message: `Are you sure you want to update fine?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.settle_dialog= false
            this.$emit('update-library-fine', 0)
          }
        }
      });
    },editFine() {
      this.$confirm({
        message: `Are you sure you want to update fine?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.edit_fine_dialog= false
            this.$emit('update-library-fine', this.payable)
          }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>